import tokens from '@gympass/yoga-tokens'

export default function getBreakpoint(size) {
  return tokens.breakpoints[size].width
}
